import Countdown from '@components/Countdown/Countdown';

type Props = {
  label?: string;
  targetDate?: string;
};

const CountdownTimer = ({ label, targetDate }: Props) => {
  return (
    <div className='tw:flex tw:animate-[fadeIn_0.5s_ease-in-out] tw:flex-col tw:items-center tw:gap-2'>
      {label && <p className='tw:mb-0 tw:text-2xl tw:font-bold'>{label}</p>}
      <Countdown targetDate={targetDate} />
    </div>
  );
};

export default CountdownTimer;
